import React from 'react';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { useTranslation } from 'react-i18next';
import classes from './CardWithStatus.module.scss';
import { timesheetsStatuses } from '../../../../../utils/constants';

export default function CardWithStatus(props) {
  const { status, clickHandler, children } = props;

  const { t } = useTranslation();

  return (
    <div
      role="presentation"
      data-testId="cardwithstatus"
      onClick={clickHandler}
      className={classes.outerContainer}
      style={{ backgroundColor: timesheetsStatuses(t)[status]?.color || '#FFFFFF' }}
    >
      <div className={classes.innerContainer}>
        {children}
        <ArrowForwardIosIcon sx={{ color: '#003B58', opacity: '0.1' }} />
      </div>
    </div>
  );
}
